import React from "react";
import { motion } from "framer-motion";
import "./WeddingIntroSection.css";
import mapImg from '../../Images/mapImg.png';
import { useNavigate } from "react-router-dom";

const WeddingIntroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="wedding-section">
      {/* Top Info Row */}
      <motion.div
        className="wedding-info-row"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="wedding-text">
          <p>
            Nestled by the serene Ganges, our wedding banquet offers a blend of
            elegance and tranquility. Celebrate your special day amidst
            breathtaking river views, lush décor, and warm hospitality—where
            every moment feels timeless and every memory sparkles with love.
          </p>
        </div>

        <motion.div
          className="wedding-map"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img
            src={mapImg}
            alt="Map location"
          />
        </motion.div>
      </motion.div>

      <hr className="wedding-divider" />

      {/* Bottom Call-to-Action */}
      <motion.div
        className="wedding-cta-box"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h3 className="wedding-cta-text">
          Start Planning your dream Wedding
        </h3>
        <motion.button
          className="wedding-cta-button"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 200 }}
          onClick={()=>navigate("/customized-booking")}
        >
          Book Now
        </motion.button>
      </motion.div>
    </section>
  );
};

export default WeddingIntroSection;
